import { render } from "./ReorganizeItems.vue?vue&type=template&id=4609d097&scoped=true"
import script from "./ReorganizeItems.vue?vue&type=script&lang=js"
export * from "./ReorganizeItems.vue?vue&type=script&lang=js"

import "./ReorganizeItems.vue?vue&type=style&index=0&id=4609d097&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4609d097"]])

export default __exports__